
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pertanyaan-umum",
      function () {
        return require("private-next-pages/pertanyaan-umum/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pertanyaan-umum"])
      });
    }
  